<app-login-page [user]="user" [authorized]="authorized" [authenticated]="authenticated" [authenticating]="authenticating" *ngIf="!authenticated || !authorized"></app-login-page>
<app-dashboard [user]="user" *ngIf="authenticated && authorized"></app-dashboard>
